<template><NumberRangeFilter field="voltage" label="Напряжение (kV)" @filter="$emit('filter',$event)"/></template>
<script>
import NumberRangeFilter from './NumberRangeFilter.vue'
export default { name:'VoltageFilter', components:{NumberRangeFilter} }
</script>
